import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Network } from '@ionic-native/network';
import { App } from 'ionic-angular';
import { StubService } from './../stub-service/stub.service';
import { Utility } from './../util-service/util-service';
import 'rxjs/add/operator/map';

@Injectable()
export class AuthServiceProvider {

    loggedIn: Boolean
    constructor(private network: Network, public http: HttpClient, private stub: StubService, private util: Utility, private app: App,) {
        console.log('AuthServiceProvider Provider');
        this.loggedIn = false;
    }

    isOnline(): boolean {
        if (this.network.type != 'none') {
            return true;
        } else {
            return false;
        }
    }

    async checkSession() {
        if (this.network.type != 'none') {
            return new Promise((resolve, reject) => {
                this.stub.do('get', 'CheckSession', null, null, 'Authenticate:CheckSession')
                    .then(res => {
                        // TODO: Maybe add a way to preserve what the user was working on if they get forced to log out due to session timeout?
                        if (this.loggedIn && (!res || !res['LoggedIn'])){
                            this.loggedIn = false;
                            this.app.getActiveNav().setRoot('LoginPage');
                        }
                        resolve(res);
                    }, (error) => {
                        reject(new Error(error));
                    });
            });
        } else {
            console.warn('Network type detected as:', this.network.type)
        }
    }

    login(data) {
        return new Promise((resolve, reject) => {
            //use Angular http for browser.
            this.util.category(false);
            this.stub.do('post', 'Authenticate', null, data, 'Authenticate:Login')
                .then(res => {
                    this.loggedIn = true;
                    resolve(res);
                }, (error) => {
                    reject(new Error(error));
                });
        });
    }

    logout() {
        if(this.isOnline()) {
            return new Promise((resolve, reject) => {
                this.stub.do('get', 'Deauthenticate', null, null, 'Authenticate:Logout')
                    .then(res => {
                        resolve();
                    }, (error) => {
                        reject(new Error(error));
                    });
            });
        } else {
            return;
        }

    }

    forgotPW(email) {
        return new Promise((resolve, reject) => {
            this.stub.do('get', `User/ForgotPassword/${email}`, null, null, 'Authenticate:forgotPassword')
                .then(res => {
                    resolve(res);
                }, (error) => {
                    // let the UI display the error messages
                    resolve({ Error: error });
                });
        });
    }

    getSessionToken() {
        return new Promise((resolve, reject) => {
            this.stub.do('get', 'CheckoutSessionToken', null, null, 'Authenticate:getSessionToken')
                .then(res => {
                    resolve(res);
                }, (error) => {
                    reject(new Error(error));
                });
        });
    }
}



// WEBPACK FOOTER //
// ./src/providers/auth-service/auth-service.ts